import is from "is_js";
import { useEffect } from "react";

const useOSClasslists = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  let isWindows = false;
  let isChrome = false;
  let isFirefox = false;
  useEffect(() => {
    if (is.windows()) {
      isWindows = true;
    }
    if (is.chrome()) {
      isChrome = true;
    }
    if (is.firefox()) {
      isFirefox = true;
    }
  }, [HTMLClassList]);

  return {
    isWindows,
    isChrome,
    isFirefox,
  };
};

export default useOSClasslists;
